import type { Components, Theme } from '@mui/material';

import { pxToRem } from '../utils';

export const getMuiChip = (rootFontSize = 16): Components<Theme>['MuiChip'] => ({
    defaultProps: {
        variant: 'filled', // default variant (4px)
    },
    styleOverrides: {
        root: {
            borderRadius: '4px',
            fontWeight: 600,
            fontSize: pxToRem(14, rootFontSize),
            // Disable ripple and avoid a warning when Chip is in a button
            // See https://github.com/mui/material-ui/issues/29033
            '& .MuiTouchRipple-root': { display: 'none' },
        },
    },
    variants: [
        {
            props: { variant: 'rounded' },
            style: {
                borderRadius: '16px',
            },
        },
    ],
});
